import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 12px 16px;
  background-color: var(--Fill_Tertiary);
  border-radius: 16px;
  display: flex;
  align-items: center;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  margin-bottom: 3px;
  white-space: nowrap;
  position: absolute;
  left: 25%;
  top: 0;
  z-index: 11;
`;
export const ContentText = styled.div`
  color: var(--Text_Primary);
  margin-left: 7px;
`;
export const LintBotton = styled.div`
  cursor: pointer;
  margin-left: 4px;
  color: var(--Text_Primary);
  font-weight: 500;
`;
export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  height: 14px;
  cursor: pointer;
  margin-left: 6px;
  color: var(--Text_Disabled);
  &:hover {
    color: var(--Text_Primary);
  }
`;
